import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { InputNumber, Checkbox, Icon } from 'antd';

import PopoverGeneric from '../commons/popoverGeneric';
import { observacioSeleccionarValorInapreciable } from '../../actions';

const titolCalculAutomatic = 'Variable calculada automàticament';
const contingutPopoverCalculAutomatic = ["La variable es calcula automàticament i pot ser editada per l'usuari"];
let lastValue = '';

class ObservacioIntroduccioVariableNumeric extends Component {
	/**
     * Indica si el input number s'ha de deshabilitar o no. retorna true si el component s'ha de deshabilitar.
     * El criteria per deshabilitar el component es::
    *       - si no es pot editar (variable.esPotEditar === false)
            - si la variables es "precipitacio total 24h"(id=34) i es inapreciable, es a dir valor === 0 i codi atribut -3
     * @param {*} variable
     * @param {*} valor
     * @return {boolean}
     */
	shaDeDeshabilitarElComponent(variable, valor) {
		const { esPotEditar } = variable;
		const esNoEditable = typeof esPotEditar === 'undefined' ? false : !esPotEditar;
		return esNoEditable || this.esPrecipitacioIValorInapreciable(variable, valor);
	}

	esPrecipitacioIValorInapreciable(variable, valor) {
		return this.esVariablePrecipitacioTotal24h(variable.idVariable) && this.esValorInapreciable(variable, valor);
	}

	esValorInapreciable(variable, valor) {
		if (typeof variable.esValorInapreciable === 'undefined') {
			return valor === '0.0' && variable.codiAtribut === '-3';
		}

		return variable.esValorInapreciable;
	}

	esVariablePrecipitacioTotal24h(idVariable) {
		const ID_VARIABLE_PRECIPITACIO_TOTAL_24h = 34;

		return idVariable === ID_VARIABLE_PRECIPITACIO_TOTAL_24h;
	}

	onChangeCheckBoxValorPrecipitacioTotal24hInapreciable(idVariable, valorCheckbox) {
		this.props.observacioSeleccionarValorInapreciable(idVariable, valorCheckbox);
	}

	onChangeValorInputNumber(valorIntroduit) {
		let valor = valorIntroduit;
		if (valorIntroduit === 0 && lastValue === '-') {
			valor = '-0';
		}
		lastValue = '' + valor;

		// AntD ens passa un string buit quan borrem el valor, i després un undefined
		if (typeof valorIntroduit === 'string' && valorIntroduit.length === 0) {
			valor = null;
		}

		this.props.onChangeValorVariable(valor);
	}

	renderCheckBoxValorPrecipitacioTotal24hInapreciable(variable, valor) {
		if (this.esVariablePrecipitacioTotal24h(variable.idVariable)) {
			return (
				<Checkbox className='text-variables-tipus-numero' style={{ marginLeft: '6px' }} checked={this.esValorInapreciable(variable, valor)} onChange={(valor) => this.onChangeCheckBoxValorPrecipitacioTotal24hInapreciable(variable.idVariable, valor.target.checked)}>
					{'ip'}
				</Checkbox>
			);
		}

		return;
	}

	informarCalculAutomatic(esValorCalculAutomatic) {
		if (esValorCalculAutomatic) {
			const contingutPopover = (
				<div className='escala-beaufort'>
					<p>{titolCalculAutomatic}</p>
					<ul>
						{contingutPopoverCalculAutomatic.map((contingut, index) => (
							<li key={index}>{contingut}</li>
						))}
					</ul>
				</div>
			);

			const icona = <Icon type='exclamation-circle' className='observacio-introduccio-popover' style={{ color: '#108ee9' }} />;

			return <PopoverGeneric contingutPopover={contingutPopover} elementBase={icona} />;
		}
	}

	render() {
		const variable = this.props.variable;
		const valor = variable.hasOwnProperty('valorNou') ? variable.valorNou : variable.valor;
		const nombreDecimals = variable.nombreDecimals;
		const valorIncremental = nombreDecimals ? 10 ** -nombreDecimals : 1;

		const deshabilitarInput = this.shaDeDeshabilitarElComponent(variable, valor);

		return (
			<div className='observacio-introduccio-variable'>
				<span className='observacio-introduccio-variable-nom'>{variable.nomVariable}</span>

				<span>
					<InputNumber step={valorIncremental} precision={nombreDecimals} value={valor} onChange={(valorIntroduit) => this.onChangeValorInputNumber(valorIntroduit)} onBlur={(event) => this.onChangeValorInputNumber(event.target.value)} disabled={deshabilitarInput} />
					&nbsp;{variable.unitats}&nbsp;
					{this.renderCheckBoxValorPrecipitacioTotal24hInapreciable(variable, valor)}
					{this.informarCalculAutomatic(variable.esValorCalculAutomatic)}
				</span>
			</div>
		);
	}
}

ObservacioIntroduccioVariableNumeric.propTypes = {
	variable: PropTypes.object,
	onChangeValorVariable: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			observacioSeleccionarValorInapreciable
		},
		dispatch
	);
};

export default connect(
	null,
	mapDispatchToProps
)(ObservacioIntroduccioVariableNumeric);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioVariableNumeric.js